import React from 'react'
import Header from '../../headerone/Main'
import { Link } from 'react-router-dom'
import First from './first'
import NewMain from '../../headerone/newMain'
import Bredcom from '../../Bredcom/Main'

function ExaminationDatesheet() {
  return (
    <>
        <NewMain />
        <Bredcom title="Home" subtitle="Examination Datesheet" />

        
        <section className="project-detail">
            <div className="container">
                <div className="lower-content">
                    <div className="row">
                        <div className="text-column col-lg-12 col-md-12 col-sm-12">

                        <h2 class="text-center"> Examination Datesheet
            </h2>
            <br/> 


                            <div className="inner-column">
                            <ul class="details_list">

                                <li> To be announced soon</li>

{/* 
                            <li><a href={`${process.env.PUBLIC_URL}/assets/img/new_images/examination_datesheet/Agriculture Theory 1st Sem. Datesheet ETE December-2024.pdf`}  target="_blank" rel="noopener"> Agriculture Theory 1st Sem. Datesheet ETE December-2024 </a></li>

<li><a href={`${process.env.PUBLIC_URL}/assets/img/new_images/examination_datesheet/AHS Dept. Theory 1st Sem. Datesheet ETE December-2024.pdf`}  target="_blank" rel="noopener"> AHS Dept. Theory 1st Sem. Datesheet ETE December-2024 </a></li>

<li><a href={`${process.env.PUBLIC_URL}/assets/img/new_images/examination_datesheet/BA(Pol.)Sc. Theory 1st Sem. Datesheet ETE December-2024.pdf`}  target="_blank" rel="noopener"> BA(Pol.)Sc. Theory 1st Sem. Datesheet ETE December-2024 </a></li>

<li><a href={`${process.env.PUBLIC_URL}/assets/img/new_images/examination_datesheet/Engg. & CA Theory 1st Sem. Datesheet ETE December-2024.pdf`}  target="_blank" rel="noopener">Engg. & CA Theory 1st Sem. Datesheet ETE December-2024 </a></li>

<li><a href={`${process.env.PUBLIC_URL}/assets/img/new_images/examination_datesheet/Law Deptt. Theory 1st Sem. Datesheet ETE December-2024.pdf`}  target="_blank" rel="noopener">Law Deptt. Theory 1st Sem. Datesheet ETE December-2024 </a></li>

<li><a href={`${process.env.PUBLIC_URL}/assets/img/new_images/examination_datesheet/Pharmacy Theory 1st Sem. Datesheet ETE December-2024.pdf`}  target="_blank" rel="noopener">Pharmacy Theory 1st Sem. Datesheet ETE December-2024 </a></li>

<li><a href={`${process.env.PUBLIC_URL}/assets/img/new_images/examination_datesheet/SBMC Deptt. Theory 1st Sem. Datesheet ETE December-2024.pdf`}  target="_blank" rel="noopener">SBMC Deptt. Theory 1st Sem. Datesheet ETE December-2024 </a></li>

  
*/}

                               
                            </ul>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </>
)
}

export default ExaminationDatesheet